import GuideDropDown from "../../components/Guide";

const routes = [
    {
        path: '/community',
        icon: "community",
        name: 'Community',
        translatedNames: {
            "JA": "コミュニティ",
            "FR": "Communauté",
            "RU": "Сообщество",
            "ZH-CN": "社区",
            "ZH-TW": "社群",
            "KK": "Қауым",
            "KO": "커뮤니티",
            "ES": "Comunidad",
            "TH": "ชุมชน",
            "TR": "Topluluk",
            "VI": "Cộng đồng",
            "UK": "Спільнота",
            "PT": "Comunidade",
            "IT": "Comunità",
        }
    },
    {
        path: '/practice',
        icon: "practice",
        name: 'Practice',
        translatedNames: {
            "JA": "練習",
            "FR": "Pratique",
            "RU": "Практика",
            "ZH-CN": "练习",
            "ZH-TW": "練習",
            "KK": "Жаттығу",
            "KO": "연습",
            "ES": "Práctica",
            "TH": "การฝึก",
            "TR": "Uygulama",
            "VI": "Thực hành",
            "UK": "Практика",
            "PT": "Prática",
            "IT": "Pratica",
        }
    },
    {
        path: '/pricing',
        icon: "pricing",
        name: 'Pricing',
        translatedNames: {
            "JA": "価格設定",
            "FR": "Tarification",
            "RU": "Ценообразование",
            "ZH-CN": "定价",
            "ZH-TW": "價格",
            "KK": "Бағаландыру",
            "KO": "가격",
            "ES": "Precios",
            "TH": "การกำหนดราคา",
            "TR": "Fiyatlandırma",
            "VI": "Giá cả",
            "UK": "Ціноутворення",
            "PT": "Preços",
            "IT": "Prezzi",
        }
    },
    {
        path: '/material',
        name: 'Material',
        icon: "material",
        translatedNames: {
            "JA": "材料",
            "FR": "Matériel",
            "RU": "Материал",
            "ZH-CN": "材料",
            "ZH-TW": "材料",
            "KK": "Материал",
            "KO": "자료",
            "ES": "Material",
            "TH": "วัสดุ",
            "TR": "Malzeme",
            "VI": "Vật liệu",
            "UK": "Матеріал",
            "PT": "Material",
            "IT": "Materiale",
        }
    },
    // , {
    //     path: '/services',
    //     icon: "services",
    //     name: 'Services',
    // }
    {
        path: '/tools',
        icon: "tools",
        name: 'Tools',
        translatedNames: {
            "JA": "ツール",
            "FR": "Outils",
            "RU": "Инструменты",
            "ZH-CN": "工具",
            "ZH-TW": "工具",
            "KK": "Құралдар",
            "KO": "도구",
            "ES": "Herramientas",
            "TH": "เครื่องมือ",
            "TR": "Araçlar",
            "VI": "Công cụ",
            "UK": "Інструменти",
            "PT": "Ferramentas",
            "IT": "Strumenti",
        },
        routes: [
            {
                path: '/tools/practice-analysis',
                name: 'Practice Analysis',
                translatedNames: {
                    "JA": "練習分析",
                    "FR": "Analyse de pratique",
                    "RU": "Анализ практики",
                    "ZH-CN": "练习分析",
                    "ZH-TW": "練習分析",
                    "KK": "Жаттығу анализі",
                    "KO": "연습 분석",
                    "ES": "Análisis de práctica",
                    "TH": "การวิเคราะห์การฝึก",
                    "TR": "Uygulama Analizi",
                    "VI": "Phân tích thực hành",
                    "UK": "Аналіз практики",
                    "PT": "Análise de prática",
                    "IT": "Analisi della pratica",
                }
            },
            {
                path: '/tools/vocabulary-list',
                name: 'Vocabulary List',
                translatedNames: {
                    "JA": "単語リスト",
                    "FR": "Liste de vocabulaire",
                    "RU": "Список слов",
                    "ZH-CN": "词汇表",
                    "ZH-TW": "詞彙表",
                    "KK": "Лексика тізімі",
                    "KO": "어휘 목록",
                    "ES": "Lista de vocabulario",
                    "TH": "รายการคำศัพท์",
                    "TR": "Kelime Listesi",
                    "VI": "Danh sách từ vựng",
                    "UK": "Словник",
                    "PT": "Lista de vocabulário",
                    "IT": "Elenco di vocaboli",
                }
            },
            {
                path: '/tools/cefr-checker',
                name: 'CEFR Checker',
                translatedNames: {
                    "JA": "CEFR チェッカー",
                    "FR": "Vérificateur de CEFR",
                    "RU": "Проверка CEFR",
                    "ZH-CN": "CEFR 检查器",
                    "ZH-TW": "CEFR 檢查器",
                    "KK": "CEFR тексеру",
                    "KO": "CEFR 확인기",
                    "ES": "Verificador de CEFR",
                    "TH": "ตรวจสอบ CEFR",
                    "TR": "CEFR Kontrolcüsü",
                    "VI": "Kiểm tra CEFR",
                    "UK": "Перевірка CEFR",
                    "PT": "Verificador CEFR",
                    "IT": "Verificatore CEFR",
                }
            },

        ]
    },
    {
        path: '/guide',
        icon: "guide",
        name: 'Guide',
        Component: GuideDropDown,
        translatedNames: {
            "JA": "ガイド",
            "FR": "Guide",
            "RU": "Руководство",
            "ZH-CN": "指南",
            "ZH-TW": "指南",
            "KK": "Нұсқаулық",
            "KO": "가이드",
            "ES": "Guía",
            "TH": "คู่มือ",
            "TR": "Kılavuz",
            "VI": "Hướng dẫn",
            "UK": "Посібник",
            "PT": "Guia",
            "IT": "Guida",
        }
    },
    {
        path: '/help',
        icon: "helpside",
        name: 'Help',
        translatedNames: {
            "JA": "ヘルプ",
            "FR": "Aide",
            "RU": "Помощь",
            "ZH-CN": "帮助",
            "ZH-TW": "幫助",
            "KK": "Көмек",
            "KO": "도움말",
            "ES": "Ayuda",
            "TH": "ช่วยเหลือ",
            "TR": "Yardım",
            "VI": "Trợ giúp",
            "UK": "Допомога",
            "PT": "Ajuda",
            "IT": "Aiuto",
        }
    },
    {
        path: '/settings',
        icon: "settingblue",
        name: 'Settings',
        translatedNames: {
            "JA": "設定",
            "FR": "Paramètres",
            "RU": "Настройки",
            "ZH-CN": "设置",
            "ZH-TW": "設置",
            "KK": "Параметрлер",
            "KO": "설정",
            "ES": "Ajustes",
            "TH": "การตั้งค่า",
            "TR": "Ayarlar",
            "VI": "Cài đặt",
            "UK": "Налаштування",
            "PT": "Configurações",
            "IT": "Impostazioni",
        }
    }

]

export default routes


